module.exports = __webpack_public_path__ + "static/media/desktop-frame-about-centered.5e1811f7.png";